/**
 * @ngdoc directive
 * @name editableField.directive:editableField
 * @description
 * Activates an editable field and backs up the initial content
 */
// @ngInject
module.exports = function () {
    return {
        require: '^editableFieldGroup',
        link: function ($scope, $element, attrs, controller) {
            $element.on('click', controller.beginEditing);
        }
    };
};
